<template>
  <page :name="_t('Modifica password')" hide-breadcrumbs>
    <pf-page-section>
      <reset-password-form style="max-width: 20rem" />
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import ResetPasswordForm from '@/components/reset-password-form.vue';
</script>
